module.exports = __webpack_public_path__ + "static/media/icon-email-active.9dc1f1e5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-email-active.svg
// module id = 1076
// module chunks = 1